var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"custom_results"},[(_vm.customResults.length)?_c('results-list',{attrs:{"results":_vm.customResults,"canDelete":""}}):_c('p',{staticClass:"empty_state"},[_vm._v("No custom results")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }